export default "__VITE_ASSET__BiNdfJTY__"